import { AngularRenderer } from 'ngx-tiptap'
import tippy from 'tippy.js'
import { SlashCommandComponent } from './slash-command.component'
import { AppInjector } from 'app/app.module'
import { Injector } from '@angular/core'
import uuid from 'short-unique-id';
import { addTag } from '../mention/add-tags'
import { GlobalService } from 'app/global/global.service'
import { formBuilder } from 'app/main/pages/general-editor-tabs/form-builder/formBuilder';
import { FormBuilderBlock } from 'app/interfaces/formbuilder'
import { Textfield } from 'app/interfaces/textfield'
import { EditorEmitterService } from 'app/main/pages/events/editor-emitter.service'
import { Blocks } from 'app/main/pages/general-editor-tabs/blocks/blocks'
import { contentBlock } from 'app/interfaces/contentBlock'
import { PageBreakBlock } from 'app/interfaces/pagebreak'
import { AttachmentBlock } from 'app/interfaces/attachments'
import { translate } from '@jsverse/transloco'
import { Type } from './command-type-enum'
import { contentFields } from "app/main/pages/general-editor-tabs/content-fields/contentFields"
import { Checkboxfield } from 'app/interfaces/checkboxfield'
import { MultichoiceField } from 'app/interfaces/multichoicefield'
import { Signaturefield } from 'app/interfaces/signaturefield'
import { PdfBlock } from 'app/interfaces/pdfblock'
import { EformStepsService } from 'app/main/pages/edit-template/eform-steps/eform-steps.service'
import { StepEnum } from 'app/main/pages/edit-template/eform-steps.dto'
import { Subject, takeUntil } from 'rxjs'
import { SelectedFieldBlock } from 'app/interfaces/fields.dto'
import { NgbModal } from '@ng-bootstrap/ng-bootstrap'
import { InternalLinkingComponent } from 'app/main/pages/edit-template/internal-linking/internal-linking.component'
const generatedUuid = new uuid({ length: 6, dictionary: 'number' });

export function editorNode(editor, range) {
    return editor
        .chain()
        .focus()
        .deleteRange(range);
}

export default {
    items: ({ query }) => {
        const destroyed = new Subject<void>();
        const globalService = AppInjector.get(GlobalService);
        const formbuilder = AppInjector.get(formBuilder);
        const editTemplate = AppInjector.get(EditorEmitterService);
        const blocks = AppInjector.get(Blocks);
        const contentField = AppInjector.get(contentFields);
        const eformStepsService = AppInjector.get(EformStepsService);
        let currentStep = eformStepsService.getActiveStep();
        eformStepsService.activeStep$.pipe(takeUntil(destroyed)).subscribe((step:StepEnum) => {
            currentStep = step;
        });
        const ngbModal = AppInjector.get(NgbModal);
        let field = {};
        const block = {};
        const options = [
            {
                name: translate("Content drop list option menu - (Template/Document - section) - Option")+ " 1",
                id: generatedUuid(),
                value: translate("Content drop list option menu - (Template/Document - section) - Option")+ " 1",
                meta_data_id: 0
            },
            { 
                name: translate("Content drop list option menu - (Template/Document - section) - Option")+ " 2",
                id: generatedUuid(),
                value: translate("Content drop list option menu - (Template/Document - section) - Option")+ " 2",
                meta_data_id: 0
            }
        ];
        let items = [
            {
                id: 1,
                title: 'Form Builder',
                command: ({ editor, range }) => {
                    editorNode(editor, range)
                    .run();
                    formbuilder.formBuilderBox({ type: 'formbuilder', editor:editor }, (data) => {
                        block[data.form_uuid] = FormBuilderBlock.block({ uuid: data.form_uuid, fields: [data.textfield_uuid] });
                        field = Textfield.tag({ type_of: 'field', uuid: data.textfield_uuid, field_info: 'custom_field', field_required: 1, column: "50" });
                        globalService.fields_data[data.textfield_uuid] = field;
                        globalService.fields_data['blocks'] = { ...globalService.fields_data['blocks'], ...block };
                    });
                    editTemplate.triggerEmitter({ initevents:true });
                },
                type: Type.FormBuilder,
            },
            {
                id: 2,
                title: 'Content box',
                command: ({ editor, range }) => {
                    editorNode(editor, range).run();
                    const uuid = blocks.createContentBox({ type: 'slashcommand', uuid: generatedUuid(), editor:editor });
                    block[uuid] = contentBlock.block({ uuid: uuid });
                    globalService.fields_data['blocks'] = { ...globalService.fields_data['blocks'], ...block };
                    editTemplate.triggerEmitter({ initevents:true });
                },
                type: Type.ContentBox,
            },
            {
                id: 3,
                title: 'Attachment',
                command: ({ editor, range }) => {
                    editorNode(editor, range).run();
                    const uuid = generatedUuid();
                    block[uuid] = AttachmentBlock.block({ uuid: uuid });
                    blocks.addAttachmentBox({ type: 'slashcommand', uuid: uuid, editor:editor });
                    globalService.fields_data['blocks'] = { ...globalService.fields_data['blocks'], ...block };
                    editTemplate.triggerEmitter({ initevents:true });
                },
                type: Type.Attachment,
            },
            {
                id: 4,
                title: 'Page Break',
                command: ({ editor, range }) => {
                    editorNode(editor, range).run();
                    const uuid = generatedUuid();
                    block[uuid] = PageBreakBlock.block({ uuid: uuid });
                    blocks.addPageBreak({ type: 'slashcommand', uuid: uuid, editor:editor });
                    globalService.fields_data['blocks'] = { ...globalService.fields_data['blocks'], ...block };
                    editTemplate.triggerEmitter({ initevents:true });
                },
                type: Type.PageBreak,
            },
            {
                id: 5,
                title: 'Text field',
                command: ({ editor, range }) => {
                    const text = {
                        id: generatedUuid(),
                        label: `[${translate("Content new field (Template/Document - section) - Field name - New field")}]`,
                        type: 'textfield',
                        name: 'Text field'
                    };
                    editorNode(editor, range)
                        .insertContent({
                            type: "mention",
                            attrs: text,
                        })
                        .run();
                    addTag(text, editor);
                },
                type: Type.TextField,
            },
            {
                id: 6,
                title: 'Datepicker',
                command: ({ editor, range }) => {
                    const datepicker = {
                        id: generatedUuid(), 
                        label: `[${translate("Content new field (Template/Document - section) - Field name - New field")}]`,
                        type: 'datepicker',
                        name: 'Datepicker'
                    }
                    editorNode(editor, range)
                        .insertContent({
                            type: "mention",
                            attrs: datepicker,
                        })
                        .run();
                    addTag(datepicker, editor);
                },
                type: Type.Datepicker,
            },
            {
                id: 7,
                title: 'Droplist',
                command: ({ editor, range }) => {
                    const droplist = {
                        id: generatedUuid(),
                        label: `[${translate("Content new field (Template/Document - section) - Field name - New field")}]`,
                        type: 'droplist',
                        name: 'Droplist'
                    }
                    editorNode(editor, range)
                        .insertContent({
                            type: "mention",
                            attrs: droplist,
                        })
                        .run();
                    addTag(droplist, editor);
                },
                type: Type.Droplist,
            },
            {
                id: 8,
                title: 'Checkbox',
                command: ({ editor, range }) => {
                    editorNode(editor, range).run();
                    contentField.addFieldBlock({ position: 'bottom', type:'checkbox', command: 'slashcommand', options:[], editor:editor }, function (uuid) {
                        const field = Checkboxfield.tag({ type_of: 'field', uuid: uuid, field_info: 'custom_field', column: "100", field_block: SelectedFieldBlock.ContentField, field_required: 1 });
                        globalService.fields_data[uuid] = field;
                        editTemplate.triggerEmitter({ initevents:true });
                    })
                },
                type: Type.Checkbox,
            },
            {
                id: 9,
                title: 'Checklist',
                command: ({ editor, range }) => {
                    editorNode(editor, range).run();
                    contentField.addFieldBlock({ position: 'bottom', type:'multichoice', command: 'slashcommand', options:options, editor:editor }, function (uuid) {
                        const field = MultichoiceField.tag({ type_of: 'field', uuid: uuid, field_info: 'custom_field', column: "100", field_block: SelectedFieldBlock.ContentField, field_required: 1, options: options });
                        globalService.fields_data[uuid] = field;
                        editTemplate.triggerEmitter({ initevents:true });
                    })
                },
                type: Type.CheckList,
            },
            {
                id: 10,
                title: 'Signature',
                command: ({ editor, range }) => {
                    editorNode(editor, range).run();
                    contentField.addFieldBlock({ position: 'bottom', type:'signature', command: 'slashcommand', options:options, editor:editor }, function (uuid) {
                        const field = Signaturefield.tag({select_type_text:"Signature", value:globalService.user_settings.signature, type_of: 'field', uuid: uuid, field_info: 'custom_field', column: "100", field_block: SelectedFieldBlock.ContentField, field_required: 1 });
                        globalService.fields_data[uuid] = field;
                        editTemplate.triggerEmitter({ initevents:true });
                    })
                },
                type: Type.Signature,
            },
            {
                id: 11,
                title: 'PDF',
                command: ({ editor, range }) => {
                    editorNode(editor, range).run();
                    const uuid = generatedUuid();
                    block[uuid] = PdfBlock.block({ uuid: uuid });
                    blocks.pdfBlockUploader({ type: 'slashcommand', uuid: uuid, editor:editor });
                    globalService.fields_data['blocks'] = { ...globalService.fields_data['blocks'], ...block };
                    editTemplate.triggerEmitter({ initevents:true });
                },
                type: Type.Pdf,
            },
            {
                id: 12,
                title: 'Internal linking',
                command: ({ editor, range }) => {
                    editorNode(editor, range).run();
                    const modalRef = ngbModal.open(InternalLinkingComponent);
                    modalRef.componentInstance._editor = editor;
                    editor.commands.blur();
                },
                type: Type.InternalLinking,
            }
        ].filter(item => item.title.toLowerCase().startsWith(query.toLowerCase()));
        if(currentStep === StepEnum.Completed){
            const allowedTypes = [Type.ContentBox, Type.TextField, Type.Datepicker, Type.Droplist]
            items = items.filter((item => allowedTypes.includes(item.type)));
        }
        return items;
    },

    render: () => {
        let component: AngularRenderer<SlashCommandComponent, SlashCommandComponent>;
        let popup;
        const injector = AppInjector.get(Injector);
        return {
            onStart: props => {
                component = new AngularRenderer(SlashCommandComponent, injector, {
                    _props:props,
                    _editor: props.editor,
                });
                if (!props.clientRect) {
                    return
                }
                popup = tippy('body', {
                    getReferenceClientRect: props.clientRect,
                    appendTo: () => document.body,
                    content: component.dom,
                    showOnCreate: true,
                    interactive: true,
                    trigger: 'manual',
                    placement: 'auto',
                    onHide() {
                        component.destroy();
                    },
                });
            },

            onUpdate(props) {
                component.updateProps({_props:props});

                if (!props.clientRect) {
                    return
                }

                popup[0].setProps({
                    getReferenceClientRect: props.clientRect,
                })
            },

            onKeyDown(props) {
                if (props.event.key === 'Escape') {
                    popup[0].hide()

                    return true
                }
                return component.instance?.onKeyDown(props)
            },

            onExit() {
                popup[0].destroy()
                component.destroy()
            },
        }
    },
}